// 客户端-INTLSDK成功率错误码 中文配置
export default {
  // 页面标题
  "error_code_title": "INTLSDK成功率错误码",

  // 筛选器
  'error_code_filter_app_version_label': 'APP版本',
  'error_code_filter_app_version_info': '',
  'error_code_filter_app_version_des': '全部',
  'error_code_filter_error_code_label': '错误码',
  'error_code_filter_error_code_info': '',
  'error_code_filter_error_code_des': '全部',
  'error_code_filter_count_label': '计数口径',
  'error_code_filter_count_info': 'Count筛选器选项决定页面的数据统计逻辑',

  // Login Success Rate 模块
  "error_code_login_success_rate": "登录成功率",
  "error_code_exclude_uer_canceled": "去除用户取消",

  // Overview 表格
  "error_code_overview": "总览",
  "error_code_login_success_device": "成功登录设备",
  "error_code_initiate_login_device": "发起登录设备",
  "error_code_share_of_login_success_device": "成功登录设备占比",
  "error_code_login_success_count": "成功登录次数",
  "error_code_initiate_login_count": "发起登录次数",
  "error_code_share_of_login_success_count": "成功登录次数占比",


  // Error Code 模块
  "error_code_error_code": "错误码",
  "error_code_error_code_share": "错误码分布",
  "error_code_error_code_trends": "错误码趋势",
  "error_code_count": "次数",
  "error_code_device": "设备",
  // 表格列
  "error_code_error_code_device": "错误码设备",
  "error_code_error_code_count": "错误码次数",
  "error_code_share_of_error_device": "错误设备占比",
  "error_code_share_of_error_count": "错误次数占比",


  // Error Code Breakdown 表格
  "error_code_error_code_breakdown": "错误码渠道信息构成",
  "error_code_error_message_from_the_third": "第三方返回错误信息",
  "error_code_device_of_error_message_from_the_third": "第三方返回错误信息设备",
  "error_code_share_of_the_third_error_device": "第三方错误设备占比",
  "error_code_count_of_error_message_from_the_third": " 第三方返回错误信息次数",
  "error_code_share_of_the_third_error_count": "第三方错误次数占比",

  // 下钻页面
  "error_code_key_metrics_ranking": "关键指标排名",

  // 国家/区域排行榜
  "error_code_country_region_breakdown": "国家/区域排行榜",
  "error_code_country": "国家",
  "error_code_region": "区域",
  "error_code_top10_country": "Top 10 国家",
  "error_code_top10_region": "Top 10 区域",

}
